function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "TV_remote"
}, /*#__PURE__*/React.createElement("title", null, "VF_TV_remote_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M170.1 113.4v141.7h-56.7V113.4h56.7M198.4 85H85v198.5h113.4V85z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "141.7",
  cy: "141.7",
  fill: "#1d1d1b",
  r: "14.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 28.4c12.6 0 25.1 2.1 37 6.1L193 9.6c-33-12.7-69.5-12.7-102.5 0l14.2 24.9c11.9-4.1 24.4-6.2 37-6.1zM141.7 70.9c5.1 0 10.3.6 15.3 1.7l14.6-25.5c-19.4-6.1-40.2-6.1-59.6 0l14.5 25.5c5-1.2 10.1-1.7 15.2-1.7z"
}))));